import { useDispatch } from 'react-redux';

import type { AppDispatch } from 'types';

export default () => {
  const dispatch = useDispatch<AppDispatch>();
  return { dispatch };
};
